import(/* webpackMode: "eager" */ "/vercel/path0/src/app/nearby/page.tsx");
